"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertOrderFormat = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    /**
     * Initial order state
     */
    OrderStatus["Draft"] = "draft";
    /**
     * The state of the payment after a payment is associated to it
     */
    OrderStatus["PaymentProcessing"] = "payment_processing";
    /**
     * The state of the order after the payment wasn't made in the payment window
     * or if the payment has timed out
     * or if the payment has been manually canceled
     * This is an end state
     */
    OrderStatus["Canceled"] = "payment_failed";
    /**
     * State after a successful payment confirmation
     */
    OrderStatus["Paid"] = "paid";
    /**
     * State when some tickets were refunded, but not all
     * The only further state is `refunded`
     */
    OrderStatus["PartiallyRefunded"] = "partially_refunded";
    /**
     * State of order after its payment is refunded
     * Should release the associated tickets
     * This is an end state
     */
    OrderStatus["Refunded"] = "refunded";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var ConvertOrderFormat;
(function (ConvertOrderFormat) {
    ConvertOrderFormat["Pdf"] = "PDF";
})(ConvertOrderFormat || (exports.ConvertOrderFormat = ConvertOrderFormat = {}));
//# sourceMappingURL=types.js.map